import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ShareIcon from "@mui/icons-material/Share";
import Avatar from "@mui/material/Avatar";
import { ASSETS } from "../../../../utils/config";
import { Alert, Snackbar, Stack } from "@mui/material";
import { colors } from "../../../../utils";
import { useState } from "react";
import UserImage from "../../../../components/UserImage";

const WorkLifeBalanceComponent = ({
  authorName = "",
  wheelName = "",
  AuthorProfile = "",
  isProfile = false,
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleShareClick = (event) => {
    event.stopPropagation();
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        setOpenSnackbar(true); // Open the snackbar on successful copy
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        width: "100%",
        px: 1,
        mx: 2,
      }}
    >
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Link copied to clipboard!
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "DM Sans",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "20px",
            color: "#123051",
          }}
          variant="h6"
          component="h1"
        >
          {isProfile ? "Gallery" : wheelName}
        </Typography>
        <IconButton
          onClick={handleShareClick}
          style={{ backgroundColor: colors.primary }}
        >
          <ShareIcon sx={{ color: colors.white }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <Avatar
          // alt="Terry Curran"
          src={{ uri: AuthorProfile }} // Replace with the path to the actual image
          sx={{ width: 42, height: 42, mr: 1 }} // Adjust size as needed
        />
        <div>
          {isProfile ? (
            <div style={{ height: "12px", width: "2px" }}></div>
          ) : (
            <Typography
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "-0.02em",
                color: "#565556",
              }}
              variant="caption"
              display="block"
            >
              Wheel by
            </Typography>
          )}
          <Typography
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              textAlign: "center",
              color: "#123051",
            }}
            variant="caption"
            display="block"
          >
            {authorName}
          </Typography>
        </div>
      </Box>
    </Box>
  );
};

export default WorkLifeBalanceComponent;
